import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { getNovedades } from '../../actions/novedades'
import ListadoArticulos from './ListadoArticulos'

export class Novedades extends Component {
  static propTypes = {
    getNovedades: PropTypes.func.isRequired,
  }

  render() {
    return (
      <Fragment>
        <div className='container-indent'>
          <div className='container-fluid-custom container-fluid-custom-mobile-padding'>
            <div className='titulo'>
              <h2>Novedades</h2>
            </div>
            <div className='row'>
              <div className='col-md-12 col-lg-12 col-xl-12'>
                <ListadoArticulos
                  mostrar='lista'
                  origen='novedades'
                />
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    )
  }
}

const mapStateToProps = state => ({})

export default connect(mapStateToProps, { getNovedades })(Novedades)
